<template>
  <v-container id="login">
    <v-form ref="form" @submit.prevent="onSubmit">
      <v-row justify="center">
        <v-col cols="12" sm="10" md="8" lg="6">
          <v-img min-height="320" src="@/assets/image/Nekologic.png">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <br />
          <v-card color="secondary" elevation="24">
            <v-container>
              <h1
                style="
                  color: yellow;
                  font-weight: bold;
                  margin: 20px;
                  text-align: center;
                "
              >
                RESET PASSWORD
              </h1>
              <b-alert show :variant="status.type" v-if="status">{{
                status.message
              }}</b-alert>
              <v-text-field
                v-model="password"
                required
                :error-messages="passwordErrors"
                placeholder="Enter new Password"
                type="password"
                @input="$v.password.$touch()"
                @blur="$v.password.$touch()"
                solo
                background-color="white"
                color="red"
              >
                <v-icon slot="prepend" color="yellow"
                  >mdi-account-key
                </v-icon></v-text-field
              >
              <v-text-field
                v-model="confPassword"
                required
                :error-messages="confPasswordErrors"
                placeholder="Repeat new Password"
                type="password"
                @input="$v.confPassword.$touch()"
                @blur="$v.confPassword.$touch()"
                solo
                background-color="white"
                color="red"
              >
                <v-icon slot="prepend" color="yellow"
                  >mdi-account-key
                </v-icon></v-text-field
              >

              <br />
              <v-row align="center" justify="space-around">
                <v-btn type="submit" tile class="ml-8" large color="yellow"
                  >Reset Password</v-btn
                >
                <v-btn tile large color="primary" @click="login"
                  >Back to Login</v-btn
                >
              </v-row>
              <br />
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <br />
    </v-form>
  </v-container>
</template>
<script>
import {mapActions} from "vuex";
import {validationMixin} from "vuelidate";
import {
  required,
  sameAs,
  integer,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    otp: {
      required,
      integer,
      minLength: minLength(6),
      maxLength: maxLength(50),
    },
    password: {required},
    confPassword: {
      required,
      sameAs: sameAs("password"),
    },
  },
  data() {
    return {
      otp: "",
      password: "",
      confPassword: "",
      status: "",
      username: "",
    };
  },
  computed: {
    passwordErrors() {
      const errors = [];
      if (this.$v.password.$dirty) {
        !this.$v.password.required && errors.push("Password is required.");
      }
      return errors;
    },
    confPasswordErrors() {
      const errors = [];
      if (this.$v.confPassword.$dirty) {
        (!this.$v.confPassword.required &&
          errors.push("Confirm password required.")) ||
          (!this.$v.confPassword.sameAs &&
            errors.push("Confirm password is not same as password."));
      }
      return errors;
    },
  },
  mounted() {
    this.status = "";
    this.username = this.$route.query.username;
  },
  methods: {
    ...mapActions([
      "RESET_PASSWORD_REQUEST",
      "showLoadingProcess",
      "closeLoading",
    ]),
    onSubmit() {
      this.$v.$touch();
      /* Checks if form is valid then make api request. */
      if (!this.$v.$invalid) {
        this.resetPassword();
      }
      this.resetPassword();
    },
    async resetPassword() {
      this.otp = this.$route.query.token;
      const {otp, password} = this;
      await this.showLoadingProcess();

      try {
        await this.RESET_PASSWORD_REQUEST({otp, password});
        this.status = {
          type: "success",
          message: "New password set successfully.",
        };
        await this.closeLoading();
      } catch (err) {
        await this.closeLoading();
        let tempStatus = {
          type: "danger",
          message: "Unknown Error, try again later!",
        };
        if (err.message === "Network Error") {
          tempStatus.message = "Poor/slow/no internet connection...";
        } else {
          const res = err.response.data;
          if (
            res.username !== undefined ||
            res.password !== undefined ||
            res.otp !== undefined
          ) {
            tempStatus.message = res;
          } else if (res.non_field_errors !== undefined) {
            tempStatus.message = res;
          }
          this.status = tempStatus;
        }
      }
    },
    login() {
      this.$router.push("/login");
    },
  },
};
</script>
